const styles = {
    globalstyle: {
      '& h1': {
          textAlign: 'left',
          fontSize: '36px',
          marginTop: '20px',
          marginBottom: '10px',
          color: '#000000',
          marginLeft: '0',
          marginRight: '0'
      },
      '& h2': {
          textAlign: 'left',
          fontSize: '30px',
          marginTop: '20px',
          marginBottom: '10px',
          color: '#000000',
          marginLeft: '0',
          marginRight: '0'
      },
      '& h3': {
          textAlign: 'left',
          fontSize: '24px',
          marginTop: '20px',
          marginBottom: '10px',
          color: '#000000',
          marginLeft: '0',
          marginRight: '0'
      },
      '& h4': {
          textAlign: 'left',
          fontSize: '18px',
          marginTop: '10px',
          marginBottom: '10px',
          color: '#000000',
          marginLeft: '0',
          marginRight: '0'
      },
      '& h5': {
          textAlign: 'left',
          color: '#000000',
          marginLeft: '0',
          marginRight: '0'
      }
  }
}

export default styles;
